import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { withDefaults } from "vue";

interface MyButtonProps {
  width?: string;
  disabled?: boolean;
  background?: string;
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    width: { default: "w-full" },
    disabled: { type: Boolean, default: false },
    background: { default: "palette5" },
    color: { default: "white" }
  },
  emits: ["click-button"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(`bg-${__props.background} text-${__props.color}  rounded ${__props.width} py-3 px-6 hover:opacity-80 disabled:opacity-20 duration-300 transition`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click-button'))),
    disabled: __props.disabled
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})